import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import { getCodes } from '../../../redux/advisor/advisor.slice';
import { styled } from '@mui/system';
import { setPageTitle } from '../../../redux/title/title.slice';
import Loader from '../../../components/ui/loader';

// Styled Components for consistent styling
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: 'none',
  padding: theme.spacing(1)
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:first-of-type': {
    '& th': {
      borderBottom: `2px solid ${theme.palette.divider}`
    }
  }
}));

function BrokerCodes() {
  const dispatch = useDispatch();
  const { codes: advisorCodes, loadingCodes } = useSelector((state) => state.advisor);

  useEffect(() => {
    dispatch(setPageTitle('My Codes'));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getCodes());
  }, [dispatch]);

  if (loadingCodes) {
    return <Loader loading={true} message="Loading you codes ..." />;
  }

  return (
    <Paper sx={{ padding: 3, width: '100%' }}>
      <Typography sx={{ mb: 2 }} variant="h5" component="h1">
        My Codes
      </Typography>

      {advisorCodes && advisorCodes.length > 0 ? (
        <TableContainer>
          <Table sx={{ border: 'none' }}>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>Provider Code</StyledTableCell>
                <StyledTableCell>Partner Code</StyledTableCell>
                <StyledTableCell>Provider</StyledTableCell>
                <StyledTableCell>Partner</StyledTableCell>
              </StyledTableRow>
            </TableHead>

            <TableBody>
              {advisorCodes.map((code) => (
                <StyledTableRow key={`${code.providerId}-${code.partnerId}`}>
                  <StyledTableCell>{code.providerCode}</StyledTableCell>
                  <StyledTableCell>{code.partnerCode}</StyledTableCell>
                  <StyledTableCell>{code.providerName}</StyledTableCell>
                  <StyledTableCell>{code.partnerName}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="h6">No Codes Found</Typography>
      )}
    </Paper>
  );
}

export default BrokerCodes;
